import api from './api';

export const getFundingSources = (businessId) =>
  api.get(`/businesses/${businessId}/funding-sources`);

export const createFundingSource = (businessId, data) =>
  api.post(`/businesses/${businessId}/funding-sources`, data);

export const updateFundingSource = (businessId, sourceId, data) =>
  api.patch(`/businesses/${businessId}/funding-sources/${sourceId}`, data);

export const createFundingAllocation = (businessId, sourceId, data) =>
  api.post(`/businesses/${businessId}/funding-sources/${sourceId}/allocations`, data);

export const getProjectFundingAllocations = (projectId) =>
  api.get(`/projects/${projectId}/funding-allocations`);
